import type { GeoPoint } from '@metro/location'
import { CITY } from '@city'

/**
 * Home-region box + airport remap — metro-domain logic (TASK-391 §3.5),
 * per city (TASK-1132): London's region is the UK with Heathrow as the
 * fallback, NYC's the New York metro area with JFK.
 *
 * This is **consumer-service** code, not part of the `Location` module:
 * `Location` only emits the raw `userCoordinate`. The metro location-
 * consumer service applies this remap. Cross-platform constants — keep the
 * London values in sync with the `metro-ios` / `metro-android` consumer
 * services.
 */

/** The city's airport coordinate — the fallback for users outside the region. */
export const AIRPORT_FALLBACK: GeoPoint = CITY.fallbackPoint

/** `true` when `point` falls inside the city's home-region box. */
export function isInsideHomeRegion(point: GeoPoint): boolean {
  const r = CITY.homeRegion
  return (
    point.latitude >= r.south &&
    point.latitude <= r.north &&
    point.longitude >= r.west &&
    point.longitude <= r.east
  )
}

/**
 * Resolves the raw user coordinate into the coordinate the app uses for
 * nearest-station lookup. Inside the region → identity; outside → the
 * airport fallback.
 */
export function appLocation(userPoint: GeoPoint): GeoPoint {
  return isInsideHomeRegion(userPoint) ? userPoint : AIRPORT_FALLBACK
}
